import { render, staticRenderFns } from "./object-card-image.vue?vue&type=template&id=730889be&"
import script from "./object-card-image.vue?vue&type=script&lang=js&"
export * from "./object-card-image.vue?vue&type=script&lang=js&"
import style0 from "./object-card-image.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports